import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import Authors from 'components/Authors';
import ReactionGroup from 'components/ReactionGroup';
import UserAvatar from 'components/UserAvatar';

import useOfferRating from 'hooks/useOfferRating';

import { useUser } from 'providers/UserProvider';

const OfferGridCardFooter = ({
  authors = [],
  className,
  offerId,
  offerComments,
  likesCount,
  userId,
  userName,
  userPhoto,
}) => {
  const { isLoggedIn } = useUser();
  const { handleVote, currentVote, serverVote } = useOfferRating(offerId);
  const onLike = useCallback(() => handleVote('GREAT'), [handleVote]);
  const onDislike = useCallback(() => handleVote('DISLIKE'), [handleVote]);

  return (
    <div
      className={twMerge(
        'mt-3 flex w-full flex-col items-start gap-y-2',
        className
      )}
    >
      {/* Avatar + nome do postador — oculto por ora */}
      <div className="hidden w-full flex-row items-center gap-x-1">
        {authors.length > 0 ? (
          <Authors
            authors={authors}
            className="col-start-1 row-span-2 row-start-1 md:row-span-1"
            firstAuthorId={userId}
            size="size6"
          />
        ) : (
          <UserAvatar
            size="size6"
            userId={userId}
            userName={userName}
            userPhoto={userPhoto}
          />
        )}
        <Text
          className="ml-1 line-clamp-1 w-full truncate break-all text-neutral-low-500 dark:text-neutral-high-300"
          size="size3"
        >
          {userName}
        </Text>
      </div>
      <div
        className="flex w-full justify-end"
        role="presentation"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <ReactionGroup
          commentsCount={offerComments}
          isLoggedIn={isLoggedIn}
          likes={Math.max(0, likesCount ?? 0)}
          offerSlug={null}
          serverVote={serverVote}
          userVote={currentVote}
          onDislike={onDislike}
          onLike={onLike}
        />
      </div>
    </div>
  );
};

OfferGridCardFooter.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      photo: PropTypes.string.isRequired,
      typeName: PropTypes.string.isRequired,
      specialityName: PropTypes.string,
      level: PropTypes.number.isRequired,
      link: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offerId: PropTypes.number.isRequired,
  offerComments: PropTypes.number.isRequired,
  likesCount: PropTypes.number.isRequired,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
};

export default memo(OfferGridCardFooter);
